import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "src/store/features/api/axiosConfig";

import {
  GetUserCurrencyTransactionsApiArg,
  GetUserCurrencyTransactionsApiResponse,
} from "src/store/features/api/generated";
import { getRuntimeConfig } from "src/getRuntimeConfig";

type Method = "get" | "post" | "put" | "delete" | "patch" | "options";
type Query = {
  url: string;
  method: Method;
  key?: string;
  data?: any;
  intercept?: boolean;
};

export const transactionsDataApi = createApi({
  reducerPath: "transactionsDataApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${getRuntimeConfig().BASE_URL}${getRuntimeConfig().SUB_PATH}`,
  }),
  endpoints: (builder) => ({
    getTransactionData: builder.query<
      GetUserCurrencyTransactionsApiResponse,
      GetUserCurrencyTransactionsApiArg
    >({
      query: (): Query => ({
        url: "/currency-transactions/transactions",
        method: "get",
      }),
    }),
  }),
});

// export const fetchTransactions = createAsyncThunk(
//   "transacactions/fetchTransactions",
//   async (payload: GetUserCurrencyTransactionsApiArg) => {
//     const response = await api.useGetUserCurrencyTransactionsQuery(payload);
//     return response.data;
//   }
// );

export const { useGetTransactionDataQuery } = transactionsDataApi;
